import { AUTH_API, handleApiError } from '../../utils/axios';

export const getRates = async (search, unpaged) => {
  try {
    const url = unpaged
      ? `/api/v1/rates?search=${search.search}`
      : `/api/v1/rates?page=${search.page}&size=${search.size}&search=${search.search}`;
    const { data } = await AUTH_API.get(url);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createRate = async (rate) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/rates`, rate);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateRate = async (rate) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/rates/${rate.id}`, rate);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteRate = async (rateId) => {
  try {
    const { data } = await AUTH_API.delete(`/api/v1/rates/${rateId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
